// 前端分页处理
export const handleList = (state) => {
  let arr = state.tableList.slice()
  return arr
}
export const getTab = (state) => {
  return state.currentMenu
}
export const getKeepAlivePage = (state) => {
  return state.keepAlivePage
}



// WEBPACK FOOTER //
// ./src/store/common/getters.js